import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'containers_pre_assessment_company_details_container';

const ids = addCyPrefixToIDs(cyPrefix, {
  INPUT_REGISTRATION_COUNTRY: 'INPUT_REGISTRATION_COUNTRY',
  INPUT_OPERATING_COUNTRY: 'INPUT_OPERATING_COUNTRY',
  INPUT_REGISTRATION_NUMBER: 'INPUT_REGISTRATION_NUMBER',
  INPUT_REGISTRATION_AUTHORITY: 'INPUT_REGISTRATION_AUTHORITY',
  INPUT_COMPANY_NAME: 'INPUT_COMPANY_NAME',
  INPUT_STORE_URL: 'INPUT_STORE_URL',
  INPUT_BUSINESS_CATEGORY: 'INPUT_BUSINESS_CATEGORY',
  INPUT_VAT_ID: 'INPUT_VAT_ID',
  VOLUME_BY_CARD: 'VOLUME_BY_CARD',
  AVERAGE_ORDER_VALUE: 'AVERAGE_ORDER_VALUE',
  BTN_BACK: 'BTN_BACK',
  BTN_SUBMIT: 'BTN_SUBMIT',
});

/**
 * We are exporting the IDS this way to help IDEs' code completion
 */
export const CY_PRE_ASSESSMENT_COMPANY_DETAILS_CONTAINER_IDS = ids;

export const tPrefix = 'products-fe.containers.pre_assessment_company_details';
